module.exports = __webpack_public_path__ + "img/assistantTop.dd155105.png";